







































































































































































































































































































































import PhoneNumber from "@/components/phoneNumber.vue";

// Composables v2.1
import useContacts from "@/composables/v2.1/useContacts";
import ContactInterface from "@/interfaces/contact.interface";
// @ts-ignore
import toastificationContent from "@/layouts/components/toastification/toastificationContent";
// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import { getCountriesAsArray, getCountryName } from "@/utils/countries";
import { resolveInitials } from "@/utils/users";
// @ts-ignore
import { required } from "@validations";
import { defineComponent, Ref, ref, watch } from "@vue/composition-api";
import {
    BAvatar,
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormInput,
    BFormSelect,
    BRow,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import contactLabels from "./components/contactLabels.vue";

extend("libphonenumber", (phone) => {
    const findCountryCode = ["+", "00"].filter((countryCode) => phone.startsWith(countryCode));
    if (findCountryCode.length === 0) {
        return false;
    }

    return isValidPhoneNumber(phone, "NL");
});

export default defineComponent({
    components: {
        PhoneNumber,
        BAvatar,
        BButton,
        BCard,
        BCardText,
        BCol,
        BFormInput,
        BFormSelect,
        BRow,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        contactLabels,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        contactId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            required,
        };
    },
    methods: {
        parsePhoneNumber(phone: string) {
            if (!phone) {
                return null;
            }

            const findCountryCode = ["+", "00"].filter((countryCode) => phone.startsWith(countryCode));
            if (findCountryCode.length === 0) {
                return phone;
            }

            if (isValidPhoneNumber(phone, "NL")) {
                // @ts-ignore
                return parsePhoneNumberFromString(phone, "NL").formatInternational();
            }

            return phone;
        },
    },
    // @ts-ignore
    setup(props, { refs }) {
        const toast = useToast();
        // @ts-ignore
        const { fetchContact, updateContact, loading, metadataFields, fetchMetadataFields } = useContacts();
        fetchMetadataFields();

        const editMode = ref(false);
        const contact: Ref<ContactInterface> = ref({
            id: 0,
            name: "",
            reference: "",
            email: "",
            phone: "",
            street: "",
            houseNumber: "",
            zipCode: "",
            city: "",
            province: "",
            company: "",
            countryCode: "",
            createdAt: "",
            jobTitle: "",
            isHighPriority: false,
            isBlocked: false,
            allowSystemMessages: true,
            labels: [],
        });
        const original = ref();

        const setContactValueFromResult = (response: ContactInterface) => {
            original.value = {
                phone: response.phone,
                email: response.email,
            };

            response.metadata = metadataFields.value.map((field: any) => {
                return response.metadata?.find((meta) => meta.name === field.name) ?? { name: field.name };
            });

            contact.value = response;
        };

        fetchContact(props.contactId, {
            params: {
                join: ["labels||id,name,color", "metadata||id,name,value"],
            },
        }).then((response: ContactInterface) => {
            setContactValueFromResult(response);
        });

        const setHighPriority = () => {
            contact.value.isHighPriority = !contact.value.isHighPriority;

            // @todo https://gitlab.just-internet.nl/saysimple-messaging-module/frontend-v2/-/merge_requests/70/diffs#diff-content-834a4ca1efc1cd19cb59571ba4b6e5dd30b17acb
            /*const notificationMessageSuccess = !contact.value.isHighPriority
                ? "context-menu.contact.notification.unvip"
                : "context-menu.contact.notification.vip";
            */

            updateContact(contact.value, original.value);
        };

        const setBlocked = () => {
            contact.value.isBlocked = !contact.value.isBlocked;
            updateContact(contact.value, original.value);
        };

        const toggleAllowSystemMessages = () => {
            contact.value.allowSystemMessages = !contact.value.allowSystemMessages;

            updateContact(contact.value, original.value).then(() => {
                toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("entities.contact.Contact"),
                        text: i18n.t(
                            contact.value.allowSystemMessages
                                ? "context-menu.contact.notification.campaign-messages-allowed"
                                : "context-menu.contact.notification.campaign-messages-disallowed"
                        ),
                        icon: "check",
                        variant: "success",
                    },
                });
            });
        };

        const localUpdateContact = () => {
            // @ts-ignore
            refs.validationRules.validate().then((success) => {
                if (success) {
                    updateContact(contact.value, original.value)
                        .then(() => {
                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("entities.contact.Contact"),
                                    text: i18n.t("toast.update.success", { entity: contact.value.name }),
                                    icon: "check",
                                    variant: "success",
                                },
                            });

                            editMode.value = false;

                            original.value = {
                                phone: contact.value.phone,
                                email: contact.value.email,
                            };
                        })
                        .catch((error) => {
                            let errorMessage = i18n.t("contacts.update-error-generic");

                            switch (error.response.data.message) {
                                case "Changing a contacts phone number is not allowed":
                                    errorMessage = i18n.t("contacts.phone-not-editable");
                                    break;
                                case "Changing a contacts email address is not allowed":
                                    errorMessage = i18n.t("contacts.email-not-editable");
                                    break;
                            }

                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("entities.contact.Contact"),
                                    text: errorMessage,
                                    icon: "times",
                                    variant: "danger",
                                },
                            });
                        });
                } else {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.contact.Contact"),
                            text: i18n.t("contacts.invalid-input"),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                }
            });
        };

        watch(
            () => props.contactId,
            // @ts-ignore
            () => {
                fetchContact(props.contactId, {
                    params: {
                        join: ["labels||id,name", "metadata||id,name,value"],
                    },
                }).then((response: ContactInterface) => {
                    setContactValueFromResult(response);
                });
            }
        );

        return {
            editMode,
            contact,
            original,
            loading,

            localUpdateContact,
            setHighPriority,
            setBlocked,
            toggleAllowSystemMessages,

            isHighPriority: false,
            isBlocked: false,

            getCountriesAsArray,
            resolveInitials,
            getCountryName,
        };
    },
});
